/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Grid from "@mui/material/Grid";
import { useState } from "react";

// @mui material components

// Argon Dashboard 2 PRO MUI components
import ServiceManager from "0.Mine/0.Components/BusinessCard/Services/Container/BusinessService";
import { useBusinessContext } from "0.Mine/2.Context/businessContext";
import ArgonBox from "components/ArgonBox";

// Argon Dashboard 2 PRO MUI example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

// NewProduct page components
import Header from "layouts/ecommerce/products/new-product/components/Header";

import BusinessPageTemplate from "./BusinessTemplate";

// Images
const bgImage =
  "https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/profile-layout-header.jpg";

function EditBusinessServices() {
  return (
    <BusinessPageTemplate title="Business Services">
      <EditBusinessServicesWithContext />
    </BusinessPageTemplate>
  );
}

function EditBusinessServicesWithContext() {
  const { session } = useBusinessContext();

  if (!session) {
    return <div>Session not found</div>;
  }

  return <ServiceManager business={session.selectedBusiness} />;
}

export default EditBusinessServices;
